export default __webpack_public_path__ + "static/media/element-infoblock.db763279.svg";